import React from "react";
import dayjs from "dayjs";

const separatorCellBase = {
  borderTop: "1px solid #D3D3D3",
  borderRight: "none",
  borderBottom: "none",
  borderLeft: "none",
  padding: 0,
};

const styles = {
  separatorSpacerCell: { ...separatorCellBase, width: "15%" },
  separatorLabelCell: { ...separatorCellBase, width: "70%" },
  separatorAmountCell: { ...separatorCellBase, width: "15%" },
  spacerCell: {
    borderTop: "none",
    borderRight: "1px solid #D3D3D3",
    borderBottom: "none",
    borderLeft: "1px solid #D3D3D3",
    padding: "3pt",
    verticalAlign: "top",
    width: "15%",
  },
  labelCell: {
    borderTop: "none",
    borderRight: "none",
    borderBottom: "none",
    borderLeft: "1px solid #D3D3D3",
    padding: "3pt",
    verticalAlign: "top",
    width: "70%",
  },
  amountCell: {
    borderTop: "none",
    borderRight: "1px solid #D3D3D3",
    borderBottom: "none",
    borderLeft: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
    width: "15%",
  },
};

const Detail = ({ label, reglements, formatCurrency, isFirst }) => {
  const detailReglements = reglements
    .map((reglement) => ({
      id: reglement.quittance_id,
      periode: `PÉRIODE DU ${dayjs(reglement.quittance_date_debut).format(
        "DD/MM/YYYY"
      )} AU ${dayjs(reglement.quittance_date_fin).format("DD/MM/YYYY")}`,
      // Rubrique "P" (Propriétaire) = somme reversée au propriétaire, seule affichée ici.
      // Rubrique "G" (Gardée) = frais conservés par le cabinet, exclus du détail du propriétaire.
      lignes: reglement.reglement_ligne
        .filter(
          (ligne) =>
            ligne.reglement_ligne_quittance_ligne_id.quittance_ligne_rubrique.rubrique_type === "P"
        )
        .sort(
          (a, b) =>
            a.reglement_ligne_quittance_ligne_id.quittance_ligne_rubrique.rubrique_id -
            b.reglement_ligne_quittance_ligne_id.quittance_ligne_rubrique.rubrique_id
        )
        .map((ligne) => ({
          id: ligne.reglement_ligne_quittance_ligne_id.quittance_ligne_rubrique.rubrique_id,
          libelle: ligne.reglement_ligne_quittance_ligne_id.quittance_ligne_libelle
            ? ligne.reglement_ligne_quittance_ligne_id.quittance_ligne_libelle
            : ligne.reglement_ligne_quittance_ligne_id.quittance_ligne_rubrique.rubrique_libelle,
          montant: ligne.reglement_ligne_montant,
        })),
    }))
    // Une période 100% "G" n'a plus aucune ligne après filtrage : on l'exclut
    // pour éviter d'afficher un en-tête "PÉRIODE DU..." vide, sans montant.
    .filter((reglement) => reglement.lignes.length > 0);

  // Si aucune période de cette location n'a de ligne "P" visible, on masque
  // toute la location (sinon son libellé s'afficherait seul, sans rien dessous).
  if (detailReglements.length === 0) {
    return null;
  }

  const rows = [
    { key: "location", label },
    ...detailReglements.flatMap((reglement) => [
      {
        key: `periode-${reglement.id}`,
        label: reglement.periode,
        strong: true,
      },
      ...reglement.lignes.map((ligne) => ({
        key: `reglement-${reglement.id}-${ligne.id}`,
        label: ligne.libelle,
        amount: formatCurrency(ligne.montant),
      })),
    ]),
  ];

  return (
    <>
      {!isFirst && (
        <tr>
          {/*<td width="15%" style={styles.separatorSpacerCell}></td>*/}
          <td width="70%" style={styles.separatorLabelCell}></td>
          <td width="15%" style={styles.separatorAmountCell}></td>
        </tr>
      )}
      {rows.map((row) => (
        <tr key={row.key}>
          {/*<td width="15%" style={styles.spacerCell}>
            {"\u00A0"}
          </td>*/}
          <td width="85%" style={styles.labelCell}>
            {row.strong ? <strong>{row.label}</strong> : row.label}
          </td>
          <td width="15%" style={styles.amountCell}>
            {row.amount || "\u00A0"}
          </td>
        </tr>
      ))}
    </>
  );
};

export default Detail;
